import React, { useEffect, useState } from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message, 
  size = 'lg' 
}) => {
  const { t } = useTranslation();
  const [localMessage, setLocalMessage] = useState(message || t('common.loading'));
  // Use semantic token instead of hardcoded colors

  useEffect(() => {
    const handleTokenRefresh = () => {
      setLocalMessage(t('common.refreshingAuth'));
      setTimeout(() => setLocalMessage(message || t('common.loading')), 2000);
    };

    const handleTokenRefreshFailed = () => {
      setLocalMessage(t('common.authFailed'));
    };

    // Listen for token refresh events
    window.addEventListener('token-refreshed', handleTokenRefresh);
    window.addEventListener('token-refresh-failed', handleTokenRefreshFailed);

    return () => {
      window.removeEventListener('token-refreshed', handleTokenRefresh);
      window.removeEventListener('token-refresh-failed', handleTokenRefreshFailed);
    };
  }, [t, message]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minH="200px"
      w="full"
    >
      <VStack spacing={4}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="primary.500"
          size={size}
        />
        <Text color="text.secondary" fontSize="sm">
          {localMessage}
        </Text>
      </VStack>
    </Box>
  );
}; 